module.exports = __webpack_public_path__ + "img/643122496026756.226cfbd8.jpg";